import React, { useState, useEffect } from 'react';
import { Container, Typography, Box, Paper, useMediaQuery, Button, IconButton } from '@mui/material';

import SnakePopup from './SnakePopup';
import UserTable from './UserTable';
import UserForm from './UserForm';
import UserRoles from './UserRoles';
import AdminRoles from './AdminRoles';
import UserProfileImage from './UserProfileImage';
import LogsAccordion from './LogsAccordion';
import AdminPopup from './AdminPopup'; // Nowy komponent, który trzeba stworzyć

import { AdminUserProvider } from './AdminUserContext';

const apiUrl = import.meta.env.VITE_API_URL;

const AdminPanel: React.FC = () => {
  const isMobile = useMediaQuery('(max-width:600px)');
  const [expanded, setExpanded] = useState<string | false>(false);
  const [role, setRole] = useState<string | null>(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isSnakeOpen, setIsSnakeOpen] = useState(false);

  useEffect(() => {
    const userRole = localStorage.getItem('role');
    setRole(userRole);
    console.log('API URL:', apiUrl);
  }, []);

  const handleAccordionChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleOpenPopup = () => setIsPopupOpen(true);
  const handleClosePopup = () => setIsPopupOpen(false);

  const handleSecretClick = () => {
    setIsSnakeOpen(true);
  };

  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', py: 4, overflowX: 'hidden' }}>
      <AdminUserProvider>
        <Container maxWidth={isMobile ? 'xs' : 'xl'}>
          <Paper sx={{ p: isMobile ? 2 : 4, position: 'relative' }}>
            <Box
              onClick={handleSecretClick}
              sx={{
                position: 'absolute',
                top: 5,
                left: 5,
                width: '20px',
                height: '20px',
                opacity: 0,
                cursor: 'default',
                zIndex: 1000,
              }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h4">
                Admin Panel
              </Typography>
              <Box>
                <Typography variant="body2" color="textSecondary" sx={{ mr: 2 }}>
                  API URL: {apiUrl}
                </Typography>
                {role === 'admin' && (
                  <Button variant="contained" onClick={handleOpenPopup}>
                    Open Scripts Popup
                  </Button>
                )}
              </Box>
            </Box>
            {role === 'admin' ? (
              <>
                <UserTable />
                <Box
                  mt={4}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                    width: '100%',
                  }}
                >
                  <AdminRoles expanded={expanded} handleAccordionChange={handleAccordionChange} />
                  <UserProfileImage expanded={expanded} handleAccordionChange={handleAccordionChange} />
                  <UserForm expanded={expanded} handleAccordionChange={handleAccordionChange} />
                  <UserRoles expanded={expanded} handleAccordionChange={handleAccordionChange} />
                  <LogsAccordion expanded={expanded} handleAccordionChange={handleAccordionChange} />
                </Box>
              </>
            ) : (
              <LogsAccordion expanded={expanded} handleAccordionChange={handleAccordionChange} />
            )}
          </Paper>
        </Container>
        {isPopupOpen && <AdminPopup open={isPopupOpen} onClose={handleClosePopup} />}
        <SnakePopup open={isSnakeOpen} onClose={() => setIsSnakeOpen(false)} />
      </AdminUserProvider>
    </Box>
  );
};

export default AdminPanel;
